import ExaminationAPI from "../../api/examination.js";
import router from "../../router";

export const examination = {
    namespaced: true,
    state: {
        examination: {},
    },
    actions: {
        EXAMINATION: ({ commit }, data) =>
            ExaminationAPI.EXAMINATION(data.id)
                .then(function (response) {
                    commit("EXAMINATION", response.data);
                })
                .catch(function () {
                    commit("EXAMINATION", {});
                }),
        RESET: ({ commit }) => {
            commit("EXAMINATION", {});
        },

        SAVE: ({ commit }, examination) => ExaminationAPI.SAVE(examination).then(({ data: ex }) => {
            commit('EXAMINATION', ex)
            examination.id ? null : router.push('/patients/' + ex.patient_id + '/examination/' + ex.id)
        }),

        PRINT: ({ }, { patient: patient, examination: examination }) => ExaminationAPI.DOWNLOAD(examination.id).then(response => {
            const url = window.URL.createObjectURL(response.data);
            const link = window.document.createElement('a');
            link.href = url;
            link.setAttribute('target', '_blank');
            link.setAttribute('download', `${moment(examination.date).format('YYYY-MM-DD')}-${patient.last_name}_${patient.first_name}.pdf`);
            window.document.body.appendChild(link);
            link.click();
        }).catch(console.log),
        DELETE: ({ state }) => ExaminationAPI.DELETE(state.examination.id),
    },

    mutations: {
        EXAMINATION: (state, Examination) => state.examination = Examination,
    }
};
